
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';

import Learn from './pages/Learn';
import Videos from './pages/Videos';
import Login from './pages/Login';
import Admin from './pages/admin';
import Enroll from './pages/Enroll';
import Dashboard from './pages/dashboard';

function App() {
  return (
   <Routes>
    <Route path='/' element={<Home/>} />
    <Route path='/enroll' element={ <Enroll/>}/>
    <Route path='/login' element={<Login/>} />
    <Route path='/admin' element={<Admin/>} />
    <Route path='/dashboard' element={<Dashboard/>} />
    <Route path='learn' element={<Learn/>}/>
    <Route path='/videos' element={<Videos/>} />
   </Routes>
  );
}

export default App;

